<template>
  <div class="flex -mx-3">
    <div class="flex-1 px-3">
      {{ ad.name }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ impressions | thousands }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ reach | thousands }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ inlineLinkClicks | thousands }}
    </div>
    <div class="w-24 px-3 text-center">{{ costPerClick }}&euro;</div>
    <div class="w-24 px-3 text-center">{{ conversions }}&#37;</div>
    <div class="w-24 px-3 text-center">{{ spend }}&euro;</div>
    <div class="w-24 px-3">
      {{ ad.status }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratItem',
  props: {
    ad: {
      type: Object,
      required: true,
    },
  },
  computed: {
    impressions() {
      return this.ad?.lifetimeReport?.impressions || 0;
    },
    reach() {
      return this.ad?.lifetimeReport?.reach || 0;
    },
    inlineLinkClicks() {
      return this.ad?.lifetimeReport?.inlineLinkClicks || 0;
    },
    spend() {
      return this.ad?.lifetimeReport?.spend || 0;
    },
    costPerClick() {
      if (!this.spend) return 0;
      if (!this.inlineLinkClicks) return this.spend;
      return 1 * (this.spend / this.inlineLinkClicks).toFixed(2);
    },
    conversions() {
      if (!this.inlineLinkClicks) return 0;
      return 1 * (this.inlineLinkClicks / this.reach).toFixed(2);
    },
  },
};
</script>
